import { render, staticRenderFns } from "./DownloadsPill.vue?vue&type=template&id=8e5d403a&scoped=true"
import script from "./DownloadsPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadsPill.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DownloadsPill.vue?vue&type=style&index=0&id=8e5d403a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d403a",
  null
  
)

export default component.exports